import { lazy, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import {
  CategoryType,
  Coupons,
  storeDetailType,
  storeType,
} from "../../controller/StoreController";
import CartInto from "./cartInfo";

import {
  UseQueryResult,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import Slider from "react-slick";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { BackButton } from "../../components/BackButton";
import CouponListModal from "../../components/modal/CouponListModal";
import GuideModal from "../../components/modal/GuideModal";
import LogController from "../../controller/LogController";
import {
  ContentStoreDataType,
  STORE_CLOSE,
  STORE_OPEN,
} from "../../controller/MasterController";
import { useBackTimer } from "../../hooks/useBackTimer";
import { authState, masterStoreState } from "../../recoil/auth";
import { guideState } from "../../recoil/guide";
import { langState, langText } from "../../recoil/lang";
import { visibleCouponListState } from "../../recoil/modal";
import { getStoreName } from "../../utils/util";
import MenuInfo from "./menuInfo";

type storeDataType = {
  store: storeType;
  menu: CategoryType[];
  detail: storeDetailType[];
  coupons: Coupons[];
};

const StoreDetails = () => {
  const location = useLocation();

  const currentDate = new Date();

  const storeList = location.state.storeList;
  const selectedIndex: number = location.state.storeIndex;
  const sliderRef = useRef<Slider>(null);

  const couponSlideRef = useRef<HTMLDivElement | null>(null);

  const queryClient = useQueryClient();

  const lang = useRecoilValue<number>(langState);

  // guideModal
  const [guideFlag, setGuideFlag] = useRecoilState<boolean>(guideState);
  const [visibleGuide, setVisibleGuide] = useState<boolean>(false);

  // const [storeDetailInfo, setStoreDetailInfo] = useState<storeDetailType[]>([]);
  // const [coupons, setCoupons] = useState<Coupons[]>([]);

  const [storeId, setStoreId] = useState<number>(0);

  const [selectedStoreIndex, setSelectedStoreIndex] =
    useState<number>(selectedIndex);

  // const [menuInfo, setMenuInfo] = useState<CategoryType[]>([]);
  const [zoom, setZoom] = useState<boolean>(false);
  const [scrollTop, setScrollTop] = useState<boolean>(false);

  // 주류 1회 확인
  const [isCheckAdult, setIsCheckAdult] = useState<boolean>(false);

  // 쿠폰 슬라이드 길이
  const [couponSlideDuration, setCouponSlideDuration] = useState<number>(
    window.innerWidth
  );

  // 터치 제어 로직
  const { resetTimer } = useBackTimer("storeDetails");

  const { data: storeData }: UseQueryResult<storeDataType> = useQuery({
    queryKey: [
      "details",
      "store_id" in storeList
        ? storeList.store_id
        : storeList[selectedStoreIndex].store_id,
    ],
    queryFn: async () => {
      const res = await ApiController.store.getKnockStoreData({
        store_id: storeId,
        parent_store_id: getRecoil(masterStoreState)!.store_id,
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        isStoreAlwaysSellingCheckoutProduct:
          "store_id" in storeList
            ? storeList.isStoreAlwaysSellingCheckoutProduct
            : storeList[selectedStoreIndex].isStoreAlwaysSellingCheckoutProduct,
      });
      if (res && res.data && res.data.data) {
        return res.data.data;
      } else throw new Error("details error");
    },
    enabled: false,
  });

  const onClickStoreItem = (storeId: number, index: number) => {
    setScrollTop(true);
    setSelectedStoreIndex(index);

    // ApiController.store.getKnockStoreData({
    //   store_id: storeId,
    //   parent_store_id: getRecoil(masterStoreState).store_id,
    //   user_token_id: getRecoil(authState).user_token_id,
    //   user_id: getRecoil(authState).user_id,
    // }),
    queryClient.prefetchQuery({
      queryKey: ["details", storeId],
      queryFn: async () => {
        const res = await ApiController.store.getKnockStoreData({
          store_id: storeId,
          parent_store_id: getRecoil(masterStoreState)!.store_id,
          user_token_id: getRecoil(authState).user_token_id,
          user_id: getRecoil(authState).user_id,
          isStoreAlwaysSellingCheckoutProduct:
            "store_id" in storeList
              ? storeList.isStoreAlwaysSellingCheckoutProduct
              : storeList[selectedStoreIndex]
                  .isStoreAlwaysSellingCheckoutProduct,
        });
        if (res && res.data && res.data.data) {
          return res.data.data;
        } else throw new Error("details error");
      },
    });
    setStoreId(storeId);
    // console.log(index);
    sliderRef.current?.slickGoTo(
      (index - 2) % (storeList as ContentStoreDataType[]).length
    );

    LogController.click({
      path: "StoreDetails",
      params: "click",
      params2: "슬라이더 매장 클릭",
      index: storeId,
    });
  };

  const onClickArrow = (index: number) => {
    const slickIndex =
      index < 0
        ? 0
        : index >= (storeList as ContentStoreDataType[]).length
        ? (storeList as ContentStoreDataType[]).length - 1
        : index % (storeList as ContentStoreDataType[]).length;

    setSelectedStoreIndex(slickIndex);

    queryClient.prefetchQuery({
      queryKey: ["details", storeList[slickIndex].store_id],
      queryFn: async () => {
        const res = await ApiController.store.getKnockStoreData({
          store_id: storeList[slickIndex].store_id,
          parent_store_id: getRecoil(masterStoreState)!.store_id,
          user_token_id: getRecoil(authState).user_token_id,
          user_id: getRecoil(authState).user_id,
          isStoreAlwaysSellingCheckoutProduct:
            "store_id" in storeList
              ? storeList.isStoreAlwaysSellingCheckoutProduct
              : storeList[selectedStoreIndex]
                  .isStoreAlwaysSellingCheckoutProduct,
        });
        if (res && res.data && res.data.data) {
          return res.data.data;
        } else throw new Error("details error");
      },
    });
    setStoreId(storeList[slickIndex].store_id);
    console.log("slickIndex", slickIndex);
    sliderRef.current?.slickGoTo(slickIndex);

    LogController.click({
      path: "StoreDetails",
      params: "click",
      params2: "슬라이더 화살표 클릭",
      index: storeList[slickIndex].store_id,
    });
  };

  const checkOpenClosingTime = (data: storeType) => {
    if (data.next_close_time && data.next_open_time) {
      const closeHours = new Date(data.next_close_time).getHours();
      const closeMinutes = new Date(data.next_close_time).getMinutes();

      const openHours = new Date(data.next_open_time).getHours();
      const openMinutes = new Date(data.next_open_time).getMinutes();

      if (
        closeHours * 60 +
          closeMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) <
          60 &&
        closeHours * 60 +
          closeMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) >
          0
      )
        return {
          status: STORE_CLOSE,
          time:
            closeHours * 60 +
            closeMinutes -
            (currentDate.getHours() * 60 + currentDate.getMinutes()),
        };

      if (
        openHours * 60 +
          openMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) <
          60 &&
        openHours * 60 +
          openMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) >
          0
      )
        return {
          status: STORE_OPEN,
          time:
            openHours * 60 +
            openMinutes -
            (currentDate.getHours() * 60 + currentDate.getMinutes()),
        };
    }
    return {
      status: "",
      time: 100,
    };
  };

  useEffect(() => {
    try {
      LogController.navigate({
        path: "StoreDetails",
        params: "navigate",
        params2: "매장상세",
        store_id:
          "store_id" in storeList
            ? storeList.store_id
            : storeList[selectedIndex].store_id,
        index:
          "store_id" in storeList
            ? storeList.store_id
            : storeList[selectedIndex].store_id,
      });
    } catch (err: any) {
      console.log(err);
    }

    if (guideFlag) {
      setGuideFlag(false);
      setVisibleGuide(true);
      LogController.event({
        path: "StoreDetails",
        params: "guide",
        params2: "가이드 모달 열림",
      });
    }

    setStoreId(
      "store_id" in storeList
        ? storeList.store_id
        : storeList[selectedIndex].store_id
    );
    // getStoreData(
    //   "store_id" in storeList
    //     ? storeList.store_id
    //     : storeList[selectedIndex].store_id
    // );
  }, []);

  // useEffect(() => {
  //   // updateManifest();
  //   // console.log("menuInfo", menuInfo);
  // }, [storeInfo]);

  useEffect(() => {
    if (!storeData) {
      console.log("refetch");
      queryClient.fetchQuery({
        queryKey: [
          "details",
          "store_id" in storeList
            ? storeList.store_id
            : storeList[selectedStoreIndex].store_id,
        ],
      });
    }
  }, [storeData]);

  useEffect(() => {
    const couponSlideItem = couponSlideRef.current;
    if (couponSlideItem) {
      setCouponSlideDuration(
        Math.max(window.innerWidth * 1.5, couponSlideItem.offsetWidth) / 70
      );
    }
  }, [storeList, storeData]);

  const CustomPrevArrow = (props: any) => {
    return (
      <div className="custom-arrow custom-next-arrow">
        <img
          className="arrow left"
          onClick={() => onClickArrow(selectedStoreIndex - 5)}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_circle_left.svg`}
          alt="ic"
        />
      </div>
    );
  };

  const CustomNextArrow = (props: any) => {
    return (
      <div className="custom-arrow custom-prev-arrow">
        <img
          className="arrow right"
          onClick={() => onClickArrow(selectedStoreIndex + 5)}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_circle_right.svg`}
          alt="ic"
        />
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 5,
    slidesToScroll: 5,
    centerPadding: "0",
    draggable: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <>
      <Style>
        <div className="wrap">
          <div
            className="container"
            onTouchStart={resetTimer}
            onClick={resetTimer}
            onScrollCapture={resetTimer}
          >
            <div className="header">
              <BackButton pathname="storeDetails" />
              {"store_id" in storeList || storeList.length === 1 ? (
                <h2 className="storeName">
                  {"store_id" in storeList
                    ? getStoreName(storeList, lang)
                    : getStoreName(storeList[0], lang)}
                </h2>
              ) : (
                <Slider ref={sliderRef} className="slider" {...settings}>
                  {storeList.map(
                    (item: ContentStoreDataType, index: number) => {
                      return (
                        <div
                          key={index}
                          className="storeItem"
                          onClick={() => onClickStoreItem(item.store_id, index)}
                        >
                          <img
                            src={item.store_img_url}
                            className={`${
                              selectedStoreIndex === index && "active"
                            }`}
                            alt="img"
                          />
                          <div className="storeTitle">
                            <p>{getStoreName(item, lang)}</p>
                          </div>
                        </div>
                      );
                    }
                  )}
                </Slider>
              )}
              <div style={{ width: "36px" }} />
            </div>
            {/* eventSlider */}
            {/* {storeInfo.next_close_time && storeInfo.next_open_time ? (
              <div className="slideWrap">
                <div className="slideBadge">
                <p>🎉 노크노크 오픈 기념 2000원 할인 쿠폰 적용됩니다.</p>
              </div>
                {checkOpenClosingTime(storeInfo).status === "close" ? (
                  <div className="slideBadge time">
                    <p>
                      ⏰ {langText.closed[lang]}
                      {checkOpenClosingTime(storeInfo).time}
                      {langText.minute[lang]}
                      {langText.deadline[lang]}
                      {langText.storeDetails_slideWrap[lang]}
                    </p>
                  </div>
                ) : (
                  checkOpenClosingTime(storeInfo).status === STORE_OPEN && (
                    <div className="slideBadge time">
                      <p>
                        ⏰ {langText.open[lang]}
                        {checkOpenClosingTime(storeInfo).time}
                        {langText.minute[lang]}
                        {langText.deadline[lang]}
                      </p>
                    </div>
                  )
                )}
              </div>
            ) : (
              <div className="slideWrap" />
            )} */}
            {storeData && storeData.coupons.length > 0 ? (
              <div className="slideWrap">
                <div
                  className="slideBadge"
                  ref={couponSlideRef}
                  onClick={() => setRecoil(visibleCouponListState, true)}
                  style={{ animationDuration: `${couponSlideDuration}s` }}
                >
                  <p>
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star_white.svg`}
                      alt="별아이콘"
                    />
                    {langText.menuInfo_event[lang]}
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star_white.svg`}
                      alt="별아이콘"
                    />
                    {getStoreName(storeList, lang)} {langText.coupon[lang]} -
                    {storeData &&
                      storeData.coupons
                        .map((data) => data.coupon_name)
                        .join(", ")}
                    {langText.coupon_slider_notice[lang]}
                  </p>
                  <button>
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_storeCoupon.svg`}
                      alt="쿠폰아이콘"
                    />
                    {langText.coupon_view[lang]}
                  </button>
                </div>
              </div>
            ) : (
              <div className="slideWrap" />
            )}
            <div className="menuWrap">
              {storeData ? (
                // <Suspense
                //   fallback={
                //     <div className="loadingWrap">
                //       <img
                //         src={`${process.env.PUBLIC_URL}/knockknock/gif/loadingImage.gif`}
                //         alt="로딩이미지"
                //       />
                //     </div>
                //   }
                // >
                <MenuInfo
                  storeId={storeId}
                  menuInfo={storeData && storeData.menu ? storeData.menu : []}
                  storeInfo={
                    storeData && storeData.store ? storeData.store : undefined
                  }
                  storeDetailInfo={
                    storeData && storeData.detail ? storeData.detail : []
                  }
                  zoom={zoom}
                  isCheckAdult={isCheckAdult}
                  setIsCheckAdult={setIsCheckAdult}
                  resetTimer={resetTimer}
                  scrollTop={scrollTop}
                  setScrollTop={setScrollTop}
                />
              ) : (
                // </Suspense>
                <div className="loadingWrap">
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/gif/loadingImage.gif`}
                    alt="로딩이미지"
                  />
                </div>
              )}
            </div>
            <div className="cartWrap">
              <CartInto
                storeInfo={
                  storeData && storeData.store ? storeData.store : undefined
                }
                coupons={
                  storeData && storeData.coupons ? storeData.coupons : undefined
                }
                resetTimer={resetTimer}
              />
            </div>
          </div>
        </div>
      </Style>
      <GuideModal
        isVisible={visibleGuide}
        setVisible={setVisibleGuide}
        store_id={storeId}
        roomTip={storeData?.store.room_tip || 0}
      />
      <CouponListModal
        coupons={storeData ? storeData.coupons : []}
        modalType="store"
        resetTimer={resetTimer}
      />
    </>
  );
};
export default StoreDetails;

const Style = styled.div`
  .container {
    width: 100%;
    max-width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }

  .header {
    height: auto;
    max-height: 11vh;
    padding-top: 20px;
    margin: 0 4%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .storeName {
      margin-left: -46px;
      font-size: 32px;
      font-weight: 300;
    }
    .backBtn {
      width: 36px;
    }
  }
  .slideWrap {
    display: flex;
    align-items: center;
    max-width: 100%;
    min-width: 100%;
    min-height: 5vh;
    overflow: hidden;
  }

  .slideBadge {
    padding: 0;
    margin: 16px 0;
    background: #ffb800;
    border-radius: 50px;
    animation: slideIn 18s linear infinite;
    display: inline-flex;
    align-items: center;

    p {
      padding: 0 20px;
      font-size: 16px;
      line-height: 30px;
      font-weight: 300;
      color: #ffffff;
      white-space: nowrap;

      img {
        margin: 0 4px;
        width: 15px;
        height: 13px;
      }
    }
    button {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      height: inherit;
      white-space: nowrap;
      background: #fff;
      color: #ffb800;
      border-radius: 50px;
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;

      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
  }
  .slideBadge.time {
    background: #ffba07;
  }

  @keyframes slideIn {
    0% {
      transform: translateX(min(120%, 120vw));
    }

    100% {
      transform: translateX(-100%);
    }
  }

  // 매장 선택 화면
  .slider {
    width: 420px;
    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }
    .arrow.left {
      left: -50px;
    }
    .arrow.right {
      right: -50px;
    }
  }
  .storeItem {
    margin: 0 2px;
    max-width: 80px;
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
      height: 70px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      object-fit: cover;
      filter: brightness(50%);
    }
    img.active {
      filter: brightness(100%);
    }
    .storeTitle {
      width: 100%;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #5e5e5e;
      padding: 0 6px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      p {
        color: #ffffff;
        font-size: 14px;
        line-height: 25px;
        font-weight: 300;
        margin: 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  /* 메뉴 */
  .menuWrap {
    overflow: auto;
  }

  /* 장바구니 */
  .cartWrap {
    height: 100%;
    max-height: 25vh;
    z-index: 999;
  }

  .loadingWrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 80%;
      object-fit: cover;
    }
  }
`;
